module.exports = __webpack_public_path__ + "static/media/photo131.f72ff4e4.jpg";